import { BASIC_INFO_LOAD, BASIC_INFO_LOAD_SUCCESS, BASIC_INFO_LOAD_FAIL } from '../actions/driverTypes.js';
import { GET_BATCH_BY_PERIOD, GET_BATCH_BY_PERIOD_SUCCESS, GET_BATCH_BY_PERIOD_FAIL } from '../actions/driverTypes.js';
import { GET_ALL_CARGO_STATES, GET_ALL_CARGO_STATES_SUCCESS, GET_ALL_CARGO_STATES_FAIL } from '../actions/driverTypes.js';
import { GET_MAWB_STATISTICS, GET_MAWB_STATISTICS_SUCCESS, GET_MAWB_STATISTICS_FAIL } from '../actions/driverTypes.js';
import { UPDATE_SCANNING_STATUS, UPDATE_SCANNING_STATUS_SUCCESS, UPDATE_SCANNING_STATUS_FAIL } from '../actions/driverTypes.js';
import { SETTLE_UNSCANNED_ORDERS, SETTLE_UNSCANNED_ORDERS_SUCCESS, SETTLE_UNSCANNED_ORDERS_FAIL } from '../actions/driverTypes.js';
import { CREATE_SUB_BATCH, CREATE_SUB_BATCH_SUCCESS, CREATE_SUB_BATCH_FAIL } from '../actions/driverTypes.js';
import { GET_BLIND_SCAN_BATCH, GET_BLIND_SCAN_BATCH_SUCCESS, GET_BLIND_SCAN_BATCH_FAIL } from '../actions/driverTypes.js';
import { SET_BLIND_SCAN_BATCH, SET_BLIND_SCAN_BATCH_SUCCESS, SET_BLIND_SCAN_BATCH_FAIL } from '../actions/driverTypes.js';
import { GET_NEXT_OPERATIONS, GET_NEXT_OPERATIONS_SUCCESS, GET_NEXT_OPERATIONS_FAIL } from '../actions/driverTypes.js';
import { UPDATE_CARGO_TRACKING, UPDATE_CARGO_TRACKING_SUCCESS, UPDATE_CARGO_TRACKING_FAIL } from '../actions/driverTypes.js';
import { UPDATE_HEAD_CELLS } from '../actions/driverTypes.js';
import { OPEN_BLIND_SCAN_BATCH_SETTING_DIALOG } from '../actions/driverTypes.js';
import { UPDATE_BATCH_COMMENTS, UPDATE_BATCH_COMMENTS_SUCCESS, UPDATE_BATCH_COMMENTS_FAIL, EDIT_CARGO_TRACKING, EDIT_CARGO_TRACKING_SUCCESS, EDIT_CARGO_TRACKING_FAIL } from '../actions/types.js'

import moment from 'moment';
import _ from 'lodash';

const initialState = {
    updateBatchComments: [],
    updateBatchCommentsLoading: false,
    updateBatchCommentsError: false,

    isLoading: false,
    basicInfoError: false,    
    isError: false,

    pageTotal: 0,

    warehouseList: [],
    batchList: [],    
    allCargoStateList: [],
    nextStepList: [],
    openChooseColumnDialog: false,
    mawbstatistics : [],
    updateScanStatusResult: "",
    settleUnscannedOrdersResult: "",
    createSubBatchResult: "",
    getBlindScanBatchResult: "",
    setBlindScanBatchResult: "",
    updateTrackingStatus: "",   
    editCargoTracking: [],
    editCargoTrackingLoading: false,
    editCargoTrackingError: false,
    openBlindScanBatchSettingDialog: false,

    scanStatusList: [
        {id: 'option_all', label: 'option_all', value: '9'},
        {id: 'is_scanning', label: 'is_scanning', value: '1'},
        {id: 'is_scan_completed', label: 'is_scan_completed', value: '2'}
    ],
    columnSelectList : [
        {id: 0,label: 'column_select_default', value: '0'},
        {id: 1,label: 'column_select_recent', value: '1'},
        {id: 2,label: 'column_select_all', value: '2'}
    ],
    headCellList: [
        { id: 'dispatch_no', label: 'dispatch_no', format: '', width: 100, checked: 1, default: 1, hidden: 0 },
        { id: 'master_air_waybill', label: 'master_air_waybill', format: '', width: 180, checked: 1, default: 1, hidden: 0 },
        { id: 'batch_type', label: 'batch_type', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'is_dispatch_completed', label: 'is_dispatch_completed', format: '', width: 100, checked: 1, default: 1, hidden: 0 },
        { id: 'description', label: 'description', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'original_airport', label: 'original_airport', format: '', width: 100, checked: 1, default: 1, hidden: 0 },
        { id: 'dest_airport', label: 'dest_airport', format: '', width: 100, checked: 1, default: 1, hidden: 0 },
        { id: 'flight_no', label: 'flight_no', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'eta', label: 'eta', format: 'date', width: 150, checked: 1, default: 1, hidden: 0 },
        { id: 'eta_date', label: 'eta_date', format: '', width: 100, checked: 0, default: 0, hidden: 1 },
        { id: 'time_left', label: 'time_left', format: '', width: 120, checked: 1, default: 1, hidden: 0 },
        { id: 'etd', label: 'etd', format: '', width: 100, checked: 0, default: 0, hidden: 1 },
        { id: 'atd', label: 'atd', format: '', width: 100, checked: 0, default: 0, hidden: 1 },
        { id: 'att', label: 'att', format: '', width: 100, checked: 0, default: 0, hidden: 1 },
        { id: 'atr', label: 'atr', format: '', width: 100, checked: 0, default: 0, hidden: 1 },
        { id: 'tracking_info', label: 'tracking_info', format: '', width: 100, checked: 1, default: 1, hidden: 0 },
        { id: 'status', label: 'status', format: '', width: 100, checked: 1, default: 1, hidden: 0 },
        { id: 'tracking_update_time', label: 'tracking_update_time', format: 'date', width: 150, checked: 1, default: 1, hidden: 0 },
        { id: 'warehouse', label: 'warehouse', format: '', width: 100, checked: 1, default: 1, hidden: 0 },
        { id: 'delivery_rate_12hrs', label: 'delivery_rate_12hrs', format: 'percent', width: 80, checked: 1, default: 1, hidden: 0 },
        { id: 'delivery_rate_24hrs', label: 'delivery_rate_24hrs', format: 'percent', width: 80, checked: 1, default: 1, hidden: 0 },
        { id: 'delivery_rate_48hrs', label: 'delivery_rate_48hrs', format: 'percent', width: 80, checked: 1, default: 1, hidden: 0 },
        { id: 'delivery_rate_60hrs', label: 'delivery_rate_60hrs', format: 'percent', width: 80, checked: 1, default: 1, hidden: 0 },
        { id: 'delivery_rate_72hrs', label: 'delivery_rate_72hrs', format: 'percent', width: 80, checked: 1, default: 1, hidden: 0 },
        { id: 'delivery_rate_now', label: 'delivery_rate_now', format: 'percent', width: 80, checked: 1, default: 1, hidden: 0 },
        { id: 'delivery_rate', label: 'delivery_rate', format: 'percent', width: 80, checked: 1, default: 1, hidden: 0 },
        { id: 'efficiency', label: 'efficiency', format: '', width: 100, checked: 1, default: 1, hidden: 0 },
        { id: 'kpi_left_days', label: 'kpi_left_days', format: '', width: 120, checked: 1, default: 1, hidden: 0 },
        { id: 'package_unattempted', label: 'package_unattempted', format: '', width: 60, checked: 1, default: 1, hidden: 0 },
        { id: 'gateway_transit', label: 'gateway_transit', format: '', width: 120, checked: 1, default: 0, hidden: 0 },
        { id: 'parcel_scanned', label: 'parcel_scanned', format: '', width: 60, checked: 1, default: 1, hidden: 0 },
        { id: 'unscanned', label: 'unscanned', format: '', width: 60, checked: 1, default: 1, hidden: 0 },
        { id: 'transshipment', label: 'transshipment', format: '', width: 60, checked: 1, default: 1, hidden: 0 },
        { id: 'transshipment_complete', label: 'transshipment_complete', format: '', width: 60, checked: 1, default: 1, hidden: 0 },
        { id: 'in_transit', label: 'in_transit', format: '', width: 60, checked: 1, default: 1, hidden: 0 },
        { id: 'delivered', label: 'delivered', format: '', width: 60, checked: 1, default: 1, hidden: 0 },
        { id: 'parcel_missing', label: 'parcel_missing', format: '', width: 60, checked: 1, default: 1, hidden: 0 },
        { id: 'parcel_rejected', label: 'parcel_rejected', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'wrong_address', label: 'wrong_address', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'all_exceptions', label: 'all_exceptions', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'return_storage', label: 'return_storage', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'in_storage', label: 'in_storage', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'total_items', label: 'total_items', format: '', width: 100, checked: 1, default: 1, hidden: 0 },
        { id: 'total_custom_checked', label: 'total_custom_checked', format: '', width: 120, checked: 0, default: 0, hidden: 0 },
        { id: 'weight', label: 'weight', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'weight_unit', label: 'weight_unit', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'total_bags', label: 'total_bags', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'boxes_transshipped', label: 'boxes_transshipped', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'boxes_transreceived', label: 'boxes_transreceived', format: '', width: 120, checked: 0, default: 0, hidden: 0 },
        { id: 'boxes_recevied', label: 'boxes_recevied', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'create_time', label: 'create_time', format: 'date', width: 150, checked: 1, default: 1, hidden: 0 },
        { id: 'partner_name', label: 'partner_name', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'partner_id', label: 'partner_id', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'cargo_receive_date', label: 'cargo_receive_date', format: 'date', width: 150, checked: 1, default: 1, hidden: 0 },
        { id: 'scan_start_date', label: 'scan_start_date', format: 'date', width: 150, checked: 1, default: 1, hidden: 0 },
        { id: 'scan_end_date', label: 'scan_end_date', format: 'date', width: 150, checked: 1, default: 1, hidden: 0 },
        { id: 'is_scanning', label: 'is_scanning', format: '', width: 120, checked: 1, default: 1, hidden: 0 },
        { id: 'is_scan_completed', label: 'is_scan_completed', format: '', width: 120, checked: 1, default: 1, hidden: 0 },
        { id: 'status_update_time', label: 'status_update_time', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'other_exception', label: 'other_exception', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'second_delivery', label: 'second_delivery', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'self_picked_up', label: 'self_picked_up', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'cr_orders', label: 'cr_orders', format: '', width: 120, checked: 0, default: 0, hidden: 0 },
        { id: 'apartment_no', label: 'apartment_no', format: '', width: 120, checked: 0, default: 0, hidden: 0 },
        { id: 'walmart_parcels', label: 'walmart_parcels', format: '', width: 140, checked: 0, default: 0, hidden: 0 },
        { id: 'payable', label: 'payable', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'invoice_ready', label: 'invoice_ready', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'is_payment_received', label: 'is_payment_received', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'payment_received_time', label: 'payment_received_time', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'is_cleared', label: 'is_cleared', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'clearing_date', label: 'clearing_date', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'receiving_report_date', label: 'receiving_report_date', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'init_report_date', label: 'init_report_date', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'snd_report_date', label: 'snd_report_date', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'final_report_date', label: 'final_report_date', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'dispatch_create_date', label: 'dispatch_create_date', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'parcel_resent', label: 'parcel_resent', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'parcel_resent_voided', label: 'parcel_resent_voided', format: '', width: 120, checked: 0, default: 0, hidden: 0 },
        { id: 'parcel_found', label: 'parcel_found', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'parcel_wrong_route', label: 'parcel_wrong_route', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'parcel_hold', label: 'parcel_hold', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'cargo_received', label: 'cargo_received', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'cargo_transsend', label: 'cargo_transsend', format: '', width: 100, checked: 0, default: 0, hidden: 0 },
        { id: 'cargo_transcomplete', label: 'cargo_transcomplete', format: '', width: 120, checked: 0, default: 0, hidden: 0 },
        { id: 'received_ratio_1', label: 'received_ratio_1', format: 'percent', width: 120, checked: 1, default: 1, hidden: 0 },
        { id: 'received_ratio_2', label: 'received_ratio_2', format: 'percent', width: 120, checked: 1, default: 1, hidden: 0 },
        { id: 'received_ratio_3', label: 'received_ratio_3', format: 'percent', width: 120, checked: 1, default: 1, hidden: 0 },
        { id: 'received_ratio_4', label: 'received_ratio_4', format: 'percent', width: 120, checked: 1, default: 1, hidden: 0 },
        { id: 'received_time_1', label: 'received_time_1', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'received_time_2', label: 'received_time_2', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'received_time_3', label: 'received_time_3', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'received_time_4', label: 'received_time_4', format: 'date', width: 150, checked: 0, default: 0, hidden: 0 },
        { id: 'received_total_ratio', label: 'received_total_ratio', format: 'percent', width: 120, checked: 0, default: 0, hidden: 0 },
    ]    
}

export default function batchManagementReducer(state = initialState, action) {
    switch(action.type) {
        case UPDATE_BATCH_COMMENTS:
            return {
                ...state,
                updateBatchCommentsLoading: true,
            }
        case UPDATE_BATCH_COMMENTS_SUCCESS:
            return {
                ...state,
                updateBatchComments: action.payload,
                updateBatchCommentsLoading: false
            }
        case UPDATE_BATCH_COMMENTS_FAIL:
            return {
                ...state,
                updateBatchCommentsLoading: false,
                updateBatchCommentsError: action.payload
            }
        case BASIC_INFO_LOAD:
            return {
                ...state,
                basicInfoError: false,            
            }
        case BASIC_INFO_LOAD_SUCCESS:
            return {
                ...state,
                warehouseList: action.payload.data.warehouses,  
                basicInfoError: false,
            }
        case BASIC_INFO_LOAD_FAIL:
            return {
                ...state,
                basicInfoError: true,
            }    
        case GET_BATCH_BY_PERIOD:
            return {
                ...state,
                isError: false,            
            }
        case GET_BATCH_BY_PERIOD_SUCCESS:
            return {
                ...state,
                batchList: action.payload.data,  
                pageTotal: action.payload.total,
                isError: false,            
            }
        case GET_BATCH_BY_PERIOD_FAIL:
            return {
                ...state,
                isError: true,
            }              
        case GET_ALL_CARGO_STATES:
            return {
                ...state,
                isError: false,            
            }
        case GET_ALL_CARGO_STATES_SUCCESS:
            return {
                ...state,
                allCargoStateList: action.payload,  
                isError: false,            
            }
        case GET_ALL_CARGO_STATES_FAIL:
            return {
                ...state,
                isError: true,
            }                                   
        case UPDATE_HEAD_CELLS:
            return {
                ...state,
                headCellList: action.payload,
            }    
        case GET_MAWB_STATISTICS:
            return {
                ...state,
                isError: false,            
            }
        case GET_MAWB_STATISTICS_SUCCESS:
            return {
                ...state,
                mawbstatistics: action.payload,  
                isError: false,            
            }
        case GET_MAWB_STATISTICS_FAIL:
            return {
                ...state,
                isError: true,
            }                                               
        case UPDATE_SCANNING_STATUS:
            return {
                ...state,
                isError: false,            
            }
        case UPDATE_SCANNING_STATUS_SUCCESS:
            return {
                ...state,
                updateScanStatusResult: action.payload,  
                isError: false,            
            }
        case UPDATE_SCANNING_STATUS_FAIL:
            return {
                ...state,
                updateScanStatusResult: "FAIL",
                isError: true,
            }                  
        case SETTLE_UNSCANNED_ORDERS:
            return {
                ...state,
                isError: false,            
            }
        case SETTLE_UNSCANNED_ORDERS_SUCCESS:
            return {
                ...state,
                settleUnscannedOrdersResult: action.payload,  
                isError: false,            
            }
        case SETTLE_UNSCANNED_ORDERS_FAIL:
            return {
                ...state,
                settleUnscannedOrdersResult: "FAIL",
                isError: true,
            }   
        case CREATE_SUB_BATCH:
            return {
                ...state,
                isError: false,            
            }
        case CREATE_SUB_BATCH_SUCCESS:
            return {
                ...state,
                createSubBatchResult: action.payload,  
                isError: false,            
            }
        case CREATE_SUB_BATCH_FAIL:
            return {
                ...state,
                createSubBatchResult: "FAIL",
                isError: true,
            }   
        case GET_BLIND_SCAN_BATCH:
            return {
                ...state,
                isError: false,            
            }
        case GET_BLIND_SCAN_BATCH_SUCCESS:
            return {
                ...state,
                getBlindScanBatchResult: action.payload,  
                isError: false,            
            }
        case GET_BLIND_SCAN_BATCH_FAIL:
            return {
                ...state,
                isError: true,
            }  
        case SET_BLIND_SCAN_BATCH:
            return {
                ...state,
                isError: false,            
            }
        case SET_BLIND_SCAN_BATCH_SUCCESS:
            return {
                ...state,
                setBlindScanBatchResult: action.payload,  
                isError: false,            
            }
        case SET_BLIND_SCAN_BATCH_FAIL:
            return {
                ...state,
                setBlindScanBatchResult: "FAIL",
                isError: true,
            }         
        case GET_NEXT_OPERATIONS:
            return {
                ...state,
                isError: false,            
            }
        case GET_NEXT_OPERATIONS_SUCCESS:
            return {
                ...state,
                nextStepList: action.payload,  
                isError: false,            
            }
        case GET_NEXT_OPERATIONS_FAIL:
            return {
                ...state,
                isError: true,
            }  
        case UPDATE_CARGO_TRACKING:
            return {
                ...state,
                updateTrackingStatus: "",            
            }
        case UPDATE_CARGO_TRACKING_SUCCESS:
            return {
                ...state,
                updateTrackingStatus: action.payload, 
            }
        case UPDATE_CARGO_TRACKING_FAIL:
            return {
                ...state,
                updateTrackingStatus: "FAIL",
            }                              
        case EDIT_CARGO_TRACKING:
            return {
                ...state,
                editCargoTrackingLoading: true
            }
        case EDIT_CARGO_TRACKING_SUCCESS:
            return {
                ...state,
                editCargoTracking: action.payload,
                editCargoTrackingLoading: false
            }
        case EDIT_CARGO_TRACKING_FAIL:
            return {
                ...state,
                editCargoTrackingLoading: false,
                editCargoTrackingError: action.payload
            }
        case OPEN_BLIND_SCAN_BATCH_SETTING_DIALOG:
            return {
                ...state,
                openBlindScanBatchSettingDialog: action.payload,
            }            
        default: 
            return state
    }
    
}
